import React from 'react';
import { useFormikContext } from 'formik';
import { LINK_IN_BIO_LIMITS, type LinkInBio } from '@repo/lib';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { ImageField } from '@dashboard/components/Formik/components/Image';
import { Input } from '@dashboard/components/ui/input';
import { Label } from '@dashboard/components/ui/label';
import { Textarea } from '@dashboard/components/ui/textarea';
import SectionCard from './SectionCard';

export default function ProfileSection() {
  const { seller } = useAuth();
  const { values, handleChange } = useFormikContext<LinkInBio>();

  return (
    <SectionCard
      title="Profile"
      description="Shown at the top of your link in bio, above your social links."
    >
      <div className="space-y-1.5">
        <Label htmlFor="avatar">Profile image (optional)</Label>
        <div className="w-fit">
          <ImageField
            id="avatar"
            name="avatar"
            image={values.avatar}
            previewSize="logo"
            crop={{ width: 512, height: 512, aspect: 1 }}
          />
        </div>
        <p className="text-xs text-muted-foreground">
          Shown in a circle. Your store logo is used when empty.
        </p>
      </div>

      <div className="space-y-1.5">
        <Label htmlFor="link-in-bio-title">Name (optional)</Label>
        <Input
          id="link-in-bio-title"
          name="title"
          value={values.title ?? ''}
          placeholder={seller.displayName}
          maxLength={LINK_IN_BIO_LIMITS.title}
          onChange={handleChange}
        />
      </div>

      <div className="space-y-1.5">
        <div className="flex items-center justify-between">
          <Label htmlFor="link-in-bio-bio">Bio (optional)</Label>
          <span className="text-xs text-muted-foreground">
            {(values.bio ?? '').length}/{LINK_IN_BIO_LIMITS.bio}
          </span>
        </div>
        <Textarea
          id="link-in-bio-bio"
          name="bio"
          rows={3}
          value={values.bio ?? ''}
          maxLength={LINK_IN_BIO_LIMITS.bio}
          placeholder="Sunday services, youth club and events for the whole family."
          onChange={handleChange}
        />
      </div>
    </SectionCard>
  );
}
